import { BACKGROUND_IMAGE_MOBILE, BACKGROUND_IMAGE_DESKTOP } from '../elements/assets'

export const LOTTIE_ANIMATION = `
...on lottieAnimation_Entry {
  id
  typeHandle

  headingAdvanced {
    html
  }
  description

  lottieFileDesktop {
    url
  }

  lottieFileMobile {
    url
  }

  ${ BACKGROUND_IMAGE_MOBILE }
  ${ BACKGROUND_IMAGE_DESKTOP }
}
`